// Публичный сайт. Админка живёт на другом origin (admin.*), поэтому root-relative
// пути картинок блога (/blog/img/...) и ссылки «Открыть на сайте» строим от него.
export const SITE_ORIGIN = (process.env.REACT_APP_SITE_ORIGIN || 'https://rabotamax.ru').replace(/\/+$/, '');

/** URL для <img> в админке: root-relative → SITE_ORIGIN + путь; абсолютные и data:/blob: — как есть. */
export function resolveSiteUrl(src: string): string {
  if (!src) return '';
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  if (src.startsWith('//')) return `https:${src}`;
  return `${SITE_ORIGIN}${src.startsWith('/') ? '' : '/'}${src}`;
}

/** Публичный адрес статьи: /blog/<hubSlug>/<slug>, без рубрики — /blog/<slug>. */
export function articleSiteUrl(slug: string, hubSlug?: string | null): string {
  const hub = (hubSlug || '').trim();
  return `${SITE_ORIGIN}/blog/${hub ? `${encodeURIComponent(hub)}/` : ''}${encodeURIComponent(slug.trim())}`;
}
